import { useAppDispatch, useAppSelector } from "../../../hooks";
import { DappNotActiveTab, NotActiveTab } from "../../layouts/NotData";
import { Link } from "react-router-dom";
import {
  getDappStudioAsync,
  selectDappStudioLoading,
  selectDappStudioStatus,
} from "../../../store/dapp-studio/dappStudioSlice";
import { Button, Flex, Loading, Typography } from "djuno-design";
import { DappPlansUrl } from "../../../utils/urls";
import { useEffect } from "react";
import DappStudioIDE from "./DappStudioIDE/DappStudioIDE";
import useServiceType from "../../../hooks/useServiceType";
import AILogo from "../../../assets/icons/ai-platform.svg?react";
import useConfigIntercomeSetting from "../../../hooks/useConfigIntercomeSetting";
import { selectOnStageEnv } from "../../../store/auth/authSlice";

const DappStudioTab = () => {
  const dappStudioStatus = useAppSelector(selectDappStudioStatus);
  const dappStudioLoading = useAppSelector(selectDappStudioLoading);

  const dispatch = useAppDispatch();

  useConfigIntercomeSetting(0, true);

  useEffect(() => {
    dispatch(getDappStudioAsync({}));
  }, [dispatch]);

  if (dappStudioLoading) {
    return (
      <Flex justify="center" items="center" className="h-[300px]">
        <Loading borderSize={2} />
      </Flex>
    );
  }

  if (dappStudioStatus !== 2) {
    return <DappNotActiveTab />;
  }

  return (
    <>
      <div className="flex transition-all duration-500 items-center justify-between gap-3">
        <div></div>
      </div>
      <DappStudioIDE />
    </>
  );
};

export const DappPlanNotActiveTab = () => {
  const { serviceType } = useServiceType(
    import.meta.env.VITE_DAPP_SERVICE_TYPE
  );

  const onStageEnv = useAppSelector(selectOnStageEnv);

  return (
    <NotActiveTab
      text={
        <Flex direction="col" items="center" className="gap-4">
          <Flex direction="col" items="center" className="gap-2">
            <AILogo className="w-20 h-20 flex-shrink-0" />
            <Typography.Text>
              Activate {serviceType?.ServiceName} to start using AI empowered
              smart contracting IDE
            </Typography.Text>
          </Flex>
          <Link to={onStageEnv?.IsAccountOwner ? DappPlansUrl : ""}>
            <Button>Active Subscription</Button>
          </Link>
        </Flex>
      }
    />
  );
};

export default DappStudioTab;
